import { Badge, Spinner, Stack, VStack } from "@chakra-ui/react"
import { Text } from "@/components"
import { DashboardData } from "@/types"

interface Props {
  isFirst: boolean
  isLoading: boolean
  label: string
  dashboardData: DashboardData | null
}

export const DashboardItem = ({ isFirst, isLoading, label, dashboardData }: Props) => {
  const fontColor = isFirst ? "white" : "black"
  return (
    <VStack
      cursor="pointer"
      bg={ isFirst ? "brand.50" : "white" }
      borderRadius={10}
      boxShadow="sm"
      _hover={{ boxShadow: "lg" }}
      w={{ base: "100%", md: "200px" }}
      align="stretch"
    >
      <Stack p={5} w="100%" gap={3}>
        <Text fontSize="sm" color={fontColor}>{label}</Text>
        {
          isLoading ? <Spinner /> : null
        }
        {
          !isLoading && !dashboardData ? <Text fontSize="sm" color={fontColor}>No Data Available</Text> : null
        }
        {
          !isLoading && dashboardData && (
            <>
              <Text fontSize="4xl" fontWeight="bold" color={fontColor}>{dashboardData.currentMonthCount.toLocaleString()}</Text>
              <Badge w="fit-content" fontSize="xs" bg={dashboardData.percentChange >= 0 ? "green.100" : "red.100"} color={dashboardData.percentChange >= 0 ? "green.800" : "red.800"}>
                {dashboardData.percentChange >= 0 ? `+${dashboardData.percentChange}%` : `-${dashboardData.percentChange}%`} From Last Month
              </Badge>
            </>
          )
        }
      </Stack>
    </VStack>
  )
}
